import { VIPER_CONST } from "../commonConstant";
import { TPublishersResponse } from "../slices/publisher/types";
import { IThemeUpdate, IRequestpublish, IUpdateThemeData } from "../types";
import * as BaseApi from "../configs/api-config";

class PublishreApiService {
  private url = (action: string) => VIPER_CONST.base_url + action;

  public async PublishApi(request: IThemeUpdate): Promise<TPublishersResponse | undefined> {
    const body = {
      username: request.username,
      sessionid: request.sessionid,
      failstatus: 0,
      request: request.request,
    };
    return BaseApi._post(this.url("getpublishrequests"), body);
  }

  public async UpdateApi(request: IThemeUpdate): Promise<IRequestpublish | undefined> {
    const body = {
      username: request.username,
      sessionid: request.sessionid,
      failstatus: 0,
      request: request.request,
    };
    return BaseApi._post(this.url("updatetheme"), body);
  }


}

const PublishreApi = new PublishreApiService();
export default PublishreApi;
